import { SITE_SETTING } from "../redux/Slices/AuthSlice";
import {
	doDelete,
	doGet,
	doPost,
	doPostProfilePictureUpload,
	doPut,
} from "./Config";
import {
	CHANGE_PASSWORD_URL,
	CHECK_AVAILIABILTY,
	CONTACT_US,
	CONTENT,
	DELETE_MEDICAL_REPORT,
	EDIT_PROFILE_URL,
	ENDCALL,
	FAQS,
	FORGOT_PASSWORD,
	GENERATE_TOKEN,
	GET_PATIENT_MEDICAL_REPORTS,
	GET_PROFILE,
	LOGIN_URL,
	OPERATIONS,
	OTP_API,
	PATIENT_APPOINTMNETS,
	PATIENT_BOOK_APPOINTMNETS,
	PATIENT_BOOK_APPOINTMNETS_DETAILS,
	PATIENT_CHAT,
	PATIENT_NEARSET_API,
	PATIENT_ORDERS,
	PATIENT_ORDERS_DETAIL,
	PATIENT_PLACE_ORDER,
	PATIENT_SEND_MESSAGE,
	PATIENT_SIGNUP,
	PATIENT_VIEW_NOTE,
	PATIENT_VIEW_PRESCRIPTION,
	PATIENTMEDICALREPORT,
	PHARMACY_EDIT_PROFILE_URL,
	PHARMACY_ORDERS_ALL,
	PHARMACY_UPDATE_STATUS,
	PHARMCY_SIGNUP,
	PHYSICIAN_APPOINTMNETS,
	PHYSICIAN_BOOK_APPOINTMNETS_CLOSE,
	PHYSICIAN_BOOK_APPOINTMNETS_DETAILS,
	PHYSICIAN_CHAT,
	PHYSICIAN_EDIT_PROFILE_URL,
	PHYSICIAN_SEND_MESSAGE,
	PHYSICIAN_SIGNUP,
	PHYSICIAN_SPECIALIZATION,
	PHYSICIAN_VIEW_NOTE,
	PHYSICIAN_VIEW_PRESCRIPTION,
	PHYSICIAN_WRITE_NOTES,
	PHYSICIAN_WRITE_PERSCRIPTION,
	PRIVACY_POLICY,
	RESET_PASSWORD,
	SIGNUPCITY,
	SIGNUPCOUNTRY,
	SIGNUPSTATE,
	SITE_SETTINTG,
	SPECIALIZATIONS,
	SYMPTOMS,
	TERMS_CONDITIONS,
	TESTIMONIALS,
	TRIGGER_CALL,
	UPDATE_PROFILE_IMAGE,
} from "./Endpoint";

export const Contactusapi = (data) => {
	return doPost(`${CONTACT_US}`, { ...data });
};
export const siteSettingapi = () => {
	return doGet(`${SITE_SETTINTG}`);
};
export const faqsApi = () => {
	return doGet(`${FAQS}`);
};
export const testiapi = () => {
	return doGet(`${TESTIMONIALS}`);
};
export const signupCountry = () => {
	return doGet(`${SIGNUPCOUNTRY}`);
};
export const signupCity = (id) => {
	return doGet(`${SIGNUPCITY}/${id}`);
};

export const signupStates = (id) => {
	return doGet(`${SIGNUPSTATE}/${id}`);
};
export const terms_condition = () => {
	return doGet(`${TERMS_CONDITIONS}`);
};
export const privacy_policy = () => {
	return doGet(`${PRIVACY_POLICY}`);
};
export const generateTokenapi = (data) => {
	return doPost(`${GENERATE_TOKEN}`, { ...data });
};
export const contentApi = (page) => {
	return doGet(`${CONTENT}${"?page"}=${page}`);
};
export const postSignIn = (data, type) => {
	return doPost(`${LOGIN_URL}${"?type"}=${type}`, { ...data });
};
export const otpApi = (data) => {
	return doPost(`${OTP_API}`, { ...data });
};
export const newpasswordApi = (data) => {
	return doPost(`${RESET_PASSWORD}`, { ...data });
};
export const forgotPasswordapi = (data, type) => {
	return doPost(`${FORGOT_PASSWORD}${"?type"}=${type}`, { ...data });
};
export const patientSignUp = (data) => {
	return doPost(`${PATIENT_SIGNUP}`, { ...data });
};
export const pharmcySignUp = (data) => {
	return doPost(`${PHARMCY_SIGNUP}`, { ...data });
};
export const physicianSignUp = (data) => {
	return doPostProfilePictureUpload(`${PHYSICIAN_SIGNUP}`, { ...data });
};
export const specializationsApi = () => {
	return doGet(`${SPECIALIZATIONS}`);
};
export const physicianOperation = (data, token) => {
	return doPost(`${OPERATIONS}`, { ...data }, token);
};
export const patientFileuploader = (data, token) => {
	return doPostProfilePictureUpload(
		`${PATIENTMEDICALREPORT}`,
		{ ...data },
		token,
	);
};
export const getpatientprofileapi = (token) => {
	return doGet(`${GET_PROFILE}`, token);
};
export const editprofileapi = (id, data, token) => {
	return doPut(`${EDIT_PROFILE_URL}/${id}`, { ...data }, token);
};

export const changeprofilepassword = (data, token, type) => {
	return doPost(`${CHANGE_PASSWORD_URL}${"?type"}=${type}`, { ...data }, token);
};

export const checkAvailiablity = (data, token) => {
	return doPost(`${CHECK_AVAILIABILTY}`, { ...data }, token);
};
export const getSymtomsapi = () => {
	return doGet(`${SYMPTOMS}`);
};

export const getPatientappointmentsapi = (filter_by, token, current_page) => {
	return doGet(
		`${PATIENT_APPOINTMNETS}${"?filter_by"}=${filter_by}${`&page`}=${current_page}`,
		token,
	);
};

export const patientBookapointment = (data, token) => {
	return doPost(`${PATIENT_BOOK_APPOINTMNETS}`, { ...data }, token);
};

export const patientBookapointmentdetail = (id, token) => {
	return doGet(`${PATIENT_BOOK_APPOINTMNETS_DETAILS}/${id}`, token);
};
export const patientOrdersapi = (token) => {
	return doGet(`${PATIENT_ORDERS}`, token);
};

export const patientDetailOrdersapi = (id, token) => {
	return doGet(`${PATIENT_ORDERS_DETAIL}/${id}`, token);
};

export const profileupdateimage = (type, data, token) => {
	return doPostProfilePictureUpload(
		`${UPDATE_PROFILE_IMAGE}${"?type"}=${type}`,
		{ ...data },
		token,
	);
};

export const getPatientmedicalreporstapi = (token) => {
	return doGet(`${GET_PATIENT_MEDICAL_REPORTS}`, token);
};

export const deleteMedicalreport = (id, token) => {
	return doDelete(`${DELETE_MEDICAL_REPORT}/${id}`, token);
};

export const physicianeditprofileapi = (id, data, token) => {
	return doPut(`${PHYSICIAN_EDIT_PROFILE_URL}/${id}`, { ...data }, token);
};

export const getPhysicianSpecializationtapi = () => {
	return doGet(`${PHYSICIAN_SPECIALIZATION}`);
};

export const getPhysicianappointmentsapi = (filter_by, token, current_page) => {
	return doGet(
		`${PHYSICIAN_APPOINTMNETS}${"?filter_by"}=${filter_by}${`&page`}=${current_page}`,
		token,
	);
};
export const getPhysicianappointmentclosesapi = (token, id, current_page) => {
	return doGet(
		`${PHYSICIAN_BOOK_APPOINTMNETS_CLOSE}/${id}${`&page`}=${current_page}`,
		token,
	);
};

export const physicianBookapointmentdetail = (id, token) => {
	return doGet(`${PHYSICIAN_BOOK_APPOINTMNETS_DETAILS}/${id}`, token);
};

export const pharmcyeditprofileapi = (id, data, token) => {
	return doPut(`${PHARMACY_EDIT_PROFILE_URL}/${id}`, { ...data }, token);
};

export const getPharmacyappointmentsapi = (filter_by, token) => {
	return doGet(`${PHARMACY_ORDERS_ALL}${"?filter"}=${filter_by}`, token);
};

export const getPharmacyappointmentsDetailsapi = (id, token) => {
	return doGet(`${PHARMACY_ORDERS_ALL}/${id}`, token);
};

export const getPharmacystaustupdatesapi = (id, status, token) => {
	return doGet(
		`${PHARMACY_UPDATE_STATUS}${"?order_id"}=${id}${"&status"}=${status}`,
		token,
	);
};

export const getPatientviewnoteapi = (appointment_id, token) => {
	return doGet(
		`${PATIENT_VIEW_NOTE}${"?appointment_id"}=${appointment_id}`,
		token,
	);
};

export const getPhysicianviewnoteapi = (appointment_id, token) => {
	return doGet(
		`${PHYSICIAN_VIEW_NOTE}${"?appointment_id"}=${appointment_id}`,
		token,
	);
};

export const getPatientchat = (appointment_id, physician_id, token) => {
	return doGet(
		`${PATIENT_CHAT}${"?appointment_id"}=${appointment_id}${"&physician_id"}=${physician_id}`,
		token,
	);
};

export const getPhysicianchat = (appointment_id, patient_id, token) => {
	return doGet(
		`${PHYSICIAN_CHAT}${"?appointment_id"}=${appointment_id}${"&patient_id"}=${patient_id}`,
		token,
	);
};

export const patientSendmessageapi = (data, token) => {
	return doPost(`${PATIENT_SEND_MESSAGE}`, { ...data }, token);
};

export const physicianSendmessageapi = (data, token) => {
	return doPost(`${PHYSICIAN_SEND_MESSAGE}`, { ...data }, token);
};

export const patientSendAttachmentApi = (formData, token) => {
	return fetch(
		`https://admin-lane-aw-health.developer-ourbase-camp.com/api/v1${PATIENT_SEND_MESSAGE}`,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		},
	);
};
export const physicianSendAttachmentApi = (formData, token) => {
	return fetch(
		`https://admin-lane-aw-health.developer-ourbase-camp.com/api/v1${PHYSICIAN_SEND_MESSAGE}`,
		{
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		},
	);
};

export const physicianSendnotesapi = (data, token) => {
	return doPost(`${PHYSICIAN_WRITE_NOTES}`, { ...data }, token);
};

export const getPatientviewperscriptionapi = (appointment_id, token) => {
	return doGet(
		`${PATIENT_VIEW_PRESCRIPTION}${"?appointment_id"}=${appointment_id}`,
		token,
	);
};

export const getPhysicianviewperscriptionapi = (appointment_id, token) => {
	return doGet(
		`${PHYSICIAN_VIEW_PRESCRIPTION}${"?appointment_id"}=${appointment_id}`,
		token,
	);
};

export const getPatientnearsetApi = (latitude, longitude, token) => {
	return doGet(
		`${PATIENT_NEARSET_API}${"?latitude"}=${latitude}${`&longitude`}=${longitude}`,
		token,
	);
};

export const patientPlaceorder = (data, token) => {
	return doPost(`${PATIENT_PLACE_ORDER}`, { ...data }, token);
};

export const physicianWriteperscription = (data, token) => {
	return doPost(`${PHYSICIAN_WRITE_PERSCRIPTION}`, { ...data }, token);
};

export const triggerApiCal = (data, token) => {
	return doPost(`${TRIGGER_CALL}`, { ...data }, token);
};

export const EndApiCal = (data, token) => {
	return doPost(`${ENDCALL}`, { ...data }, token);
};
